import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";
import { History } from "lucide-react";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useGetOverview } from "../hooks/overview";
import useOverviewStore from "../store/overview";
import VersionHistoryItem from "./VersionHistoryItem";

const VersionHistoryDrawer = () => {
  const { versions } = useOverviewStore();
  const sheetRef = useRef(null);
  const { getByVersion } = useGetOverview();
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    if (!isOpen) {
      document.body.style.pointerEvents = ""; // Ensure reset on close
    }
  }, [isOpen]);

  const orderedVersions = useMemo(() => {
    return versions.sort((a, b) => {
      //createdAt
      return new Date(b.createdAt) - new Date(a.createdAt);
    });
  }, [versions]);
  return (
    <Sheet open={isOpen} onOpenChange={setIsOpen}>
      <SheetTrigger asChild>
        <Button
          variant="ghost"
          className="rounded h-auto bg-muted text-gray-400 hover:text-white"
        >
          <History className="" />
          Latest version
        </Button>
      </SheetTrigger>
      <SheetContent ref={sheetRef}>
        <SheetHeader>
          <SheetTitle>Version history</SheetTitle>
        </SheetHeader>
        <div className="flex flex-col">
          {orderedVersions.map((item, index) => (
            <VersionHistoryItem
              {...item}
              key={item.id}
              parentRef={sheetRef}
              onViewChangeLog={() => {}}
              onLoadVersion={() => {
                getByVersion(item.id);
                setIsOpen(false);
              }}
            />
          ))}
        </div>
      </SheetContent>
    </Sheet>
  );
};
export default VersionHistoryDrawer;
